<i18n locale="en">
{
  "privacy": "privacy.",
  "terms": "terms",
  "general-warning": "By using the Owner.com dashboard, you accept our",
  "register-warning": "By creating an account, you accept our"
}
</i18n>

<template>
  <span class="legal-info text-paragraph-small text-color-secondary">
    {{ t(`${type}-warning`) }}
    <a
      class="legal-info__link misc-brand"
      :href="termsUrl"
      target="_blank"
      v-text="t('terms')"
    ></a>
    {{ t('general.and') }}
    <a
      class="legal-info__link misc-brand"
      :href="privacyUrl"
      target="_blank"
      v-text="t('privacy')"
    ></a>
  </span>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const NEPTUNE_URL = import.meta.env.VITE_LANDING_URL

withDefaults(
  defineProps<{
    type?: string
  }>(),
  {
    type: 'general',
  }
)

const { t } = useI18n()

const privacyUrl = encodeURI(`${NEPTUNE_URL}/privacy-policy/`)
const termsUrl = encodeURI(`${NEPTUNE_URL}/restaurant-participation-agreement/`)
</script>

<style lang="scss" scoped>
.legal-info {
  word-break: break-word;
}
</style>
